import Swiper from 'swiper/bundle';

export default function initializeLogotypes() {
    document.querySelectorAll(
        '.logotypes-slider:not(.logotypes-slider--disabled)' ).
        forEach( function( slider ) {
            const swiper = new Swiper( slider, {
                speed: 1000,
                loop: true,
                spaceBetween: 2,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: slider.querySelector( '.logotypes-slider__arrow--next' ),
                    prevEl: slider.querySelector( '.logotypes-slider__arrow--prev' ),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: Math.ceil( parseInt( slider.dataset.cols ) / 2 ),
                        loopAdditionalSlides: 0,
                    },
                    1200: {
                        slidesPerView: parseInt( slider.dataset.cols ),
                    },
                },
            } );
        } );
}